var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-tabs-container"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"tab-container",class:tab.id === _vm.selectedTab ? 'selected-tab' : '',on:{"click":function($event){return _vm.onSelectTab(tab.id)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }